import { render } from "./FilterCluster.vue?vue&type=template&id=66b6e47a"
import script from "./FilterCluster.vue?vue&type=script&lang=js"
export * from "./FilterCluster.vue?vue&type=script&lang=js"
script.render = render

export default script